<app-view-title Title="{{ 'Intellitrailer.Booking.UnConfirmedBooking.TitleMyBooking' | translate : 'My booking' }}" mode="soft"></app-view-title>

<view-content [centered]="true">
  @if(booking) {
    <app-rental-box [booking]="booking" [hasLock]="hasLock" [allowUnmanned]="allowUnmanned" [isNuwiel]="isNuwiel" [isPickup]="true" (rentalAction)="recieveRentalAction($event)"></app-rental-box>
  }

  @if(booking && !booking.IsOneWay && !tooFarAway && !tooEarly){
  <div class="link" (click)="cantFindTrailer()"> {{ 'Intellitrailer.Rental.BookingInfo.btnMyTrailerInstHere' | translate : 'My trailer isn´t here.' }}</div>
  }

 </view-content>

